import React from 'react';
import style from './index.module.css';
import logo from "../../assets/images/logo.png"
import {useLocation, useNavigate} from "react-router-dom";
import {fileBaseUrl, formattedNowDate, showFail, showWarning} from "../../utils";
import SecondPage from "../secondPage";
import ThirdPage from "../thirdPage";
import FourthPage from "../fourthPage";
import FifthPage from "../fifthPage";
import SixthPage from "../sixthPage";
import SeventhPage from "../seventhPage";
import EighthPage from "../eighthPage";
import {Button, Card, Carousel, Divider, Dropdown, Menu, Tabs} from 'antd';
import bac_1 from "../../assets/images/huzhou_bac.png"
import bac_2 from "../../assets/images/bac_2.png"
import bac_3 from "../../assets/images/bac_1.png"
// import bac_3 from "../../assets/images/bac_3.png"
import s_bac_1 from "../../assets/images/s_bac_1.jpg"
import s_bac_2 from "../../assets/images/s_bac_2.jpg"
import s_bac_3 from "../../assets/images/s_bac_3.jpg"
import re1 from "../../assets/images/re_1.jpg"
import re2 from "../../assets/images/re_2.jpg"
import ca1 from "../../assets/images/ca1.png"
import ca2 from "../../assets/images/ca2.png"
import ca3 from "../../assets/images/ca3.png"
import ca4 from "../../assets/images/ca4.png"
import ca5 from "../../assets/images/ca5.png"
import ca6 from "../../assets/images/ca6.png"
import ca7 from "../../assets/images/ca7.png"
import ca8 from "../../assets/images/ca8.png"
import ca9 from "../../assets/images/ca9.png"
import searchIcon from "../../assets/icons/search_1.svg"
import onlineIcon from "../../assets/icons/online.svg"
import auditIcon from "../../assets/icons/audit.svg"
import cpAuditIcon from "../../assets/icons/cpAudit.svg"
import qrCode from "../../assets/images/liangshan_qrcode.png"
import linkPic1 from "../../assets/images/linkPic1.jpg"
import linkPic2 from "../../assets/images/linkPic2.jpg"
import linkPic3 from "../../assets/images/linkPic3.jpg"
import linkPic4 from "../../assets/images/linkPic4.jpg"
import linkPic5 from "../../assets/images/linkPic5.jpg"
import linkPic6 from "../../assets/images/linkPic6.jpg"
import linkPic7 from "../../assets/images/linkPic7.jpg"
import professionalIcon from "../../assets/icons/professional.svg"
import clockIcon from "../../assets/icons/clock.svg"
import priceIcon from "../../assets/icons/price.svg"
import type {MenuProps} from 'antd';
import HireInformation from "../hireInformation";
import CertificateNotice from "../certificateNotice";
import CertSearch from "../certSearch";
import filingPng from "../../assets/images/filing.png"


const FirstPage = () => {
    const today = formattedNowDate();
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;
    console.log('path', path);

    const downloadFile = (url: string) => {
        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
    };


    const aboutItems: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <div className={style.menuItem} onClick={() => {
                    navigate('/about', {state: {subPath: 'c1'}})
                }}>
                    机构简介
                </div>
            ),
        },
        {
            key: '2',
            label: (
                <div className={style.menuItem} onClick={() => {
                    navigate('/about', {state: {subPath: 'c2'}})
                }}>
                    组织架构
                </div>
            ),
        },
    ];

    const certificationItems: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <div className={style.menuItem} onClick={() => {
                    navigate('/certification', {state: {subPath: 'c1'}})
                }}>
                    认证业务范围
                </div>
            ),
        },
        {
            key: '2',
            label: (
                <div className={style.menuItem} onClick={() => {
                    navigate('/certification', {state: {subPath: 'c2'}})
                }}>
                    认证实施规则
                </div>
            ),
        },
        {
            key: '3',
            label: (
                <div className={style.menuItem} onClick={() => {
                    navigate('/certification', {state: {subPath: 'c3'}})
                }}>
                    公开文件
                </div>
            ),
        },
    ];

    const informationItems: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <div className={style.menuItem} onClick={() => {
                    navigate('/information', {state: {subPath: 'c1'}})
                }}>
                    通知公告
                </div>
            ),
        },
        {
            key: '2',
            label: (
                <div className={style.menuItem} onClick={() => {
                    navigate('/information', {state: {subPath: 'c2'}})
                }}>
                    行业动态
                </div>
            ),
        },
        {
            key: '3',
            label: (
                <div className={style.menuItem} onClick={() => {
                    navigate('/information', {state: {subPath: 'c3'}})
                }}>
                    政策法规
                </div>
            ),
        },
    ];


    const noticeData = [
        {
            id: 11,
            name: "全市首个行业碳基础数据库顺利验收投用",
            time: "2024-11-01",
        },
        {
            id: 12,
            name: "全市国企首个双碳领域认证资质",
            time: "2024-10-14",
        },
        {
            id: 6,
            name: "市场监管总局关于发布 《温室气体自愿减排项目审定与减排量核查实施规则》的公告",
            time: "2023-12-27",
        },
        {
            id: 7,
            name: "碳达峰碳中和质量认证体系建设工作座谈会在京召开",
            time: "2023-12-22",
        },
        {
            id: 13,
            name: "市产业集团赴京洽谈“双碳”认证试点工作推进会",
            time: "2023-08-11",
        },
    ];

    const industryData = [
        {
            id: 101,
            name: "国家认监委关于开展电动自行车用锂离子蓄电池、电动自行车用充电器、可燃气体探测报警产品强制性产品认证实施机构指定工作的公告",
            time: "2024-08-01",
        },
        {
            id: 102,
            name: "助推内外贸一体化发展 浙江累计发展“三同”产品超2000种",
            time: "2024-07-19",
        },
    ];

    const lawData = [
        {
            id: 201,
            name: "《认证证书和认证标志管理办法》",
            time: "2018-10-08",
        },
        {
            id: 202,
            name: "《质量管理体系认证规则》",
            time: "2019-10-11",
        },
        {
            id: 203,
            name: "《中华人民共和国认证认可条例》（2020年修订版）",
            time: "2020-12-01",
        },
        {
            id: 204,
            name: "《中华人民共和国产品质量法》",
            time: "2018-11-15",
        },
        {
            id: 205,
            name: "《中华人民共和国计量法》",
            time: "2018-10-20",
        },
    ];

    const noticeItems: any[] = [
        {
            key: "1",
            label: "通知公告",
            children: (
                <div>
                    {noticeData?.map((d: any) => (
                        <div className={style.eachNew} onClick={() => {
                            navigate('/information', {state: {subPath: 'c1', articleId: d?.id}})
                        }}>{d?.name} <span
                            style={{position: "absolute", right: 5}}>{d?.time}</span></div>
                    ))}
                </div>
            )
        },
        {
            key: "2",
            label: "行业动态",
            children: (
                <div>
                    {industryData?.map((d: any) => (
                        <div className={style.eachNew} onClick={() => {
                            navigate('/information', {state: {subPath: 'c2', articleId: d?.id}})
                        }}>{d?.name} <span
                            style={{position: "absolute", right: 5}}>{d?.time}</span></div>
                    ))}
                </div>
            )
        },
    ]

    const comFile = fileBaseUrl();

    return (
        <div className={style.content}>
            <div className={style.header}>
                <div className={style.headerCenter}>
                    <div>
                        欢迎登录湖州市两山生态资源认证有限公司官网！
                    </div>
                    <div>
                        {today}
                    </div>
                </div>
            </div>

            <div className={style.titleArea}>
                <div>
                    <img src={logo} width={100} height={100} alt=""/>
                </div>
                <div className={style.title}>
                    <div className={style.title_cn}>
                        湖州市两山生态资源认证有限公司
                    </div>

                    <div className={style.title_en}>
                        LIANGSHAN CERTIFICATION CO.,LTD
                    </div>
                </div>

            </div>

            <div className={style.navLine}>
                <div className={style.leftNavBlock} onClick={() => {
                    navigate('/index')
                }}>
                    首页
                </div>

                {/*<div className={style.divider_1} />*/}
                {/*<div className={style.divider_2} />*/}

                <Dropdown overlay={<Menu items={aboutItems}/>} placement="bottomLeft">
                    <div className={style.navBlock} onClick={() => {
                        navigate('/about', {state: {subPath: 'c1'}})
                    }}>
                        关于我们
                    </div>
                </Dropdown>


                <Dropdown overlay={<Menu items={certificationItems}/>} placement="bottomLeft">
                    <div className={style.navBlock} onClick={() => {
                        navigate('/certification', {state: {subPath: 'c1'}})
                    }}>
                        认证服务
                    </div>
                </Dropdown>

                <Dropdown overlay={<Menu items={informationItems}/>} placement="bottomLeft">
                    <div className={style.navBlock} onClick={() => {
                        navigate('/information', {state: {subPath: 'c1'}})
                    }}>
                        信息中心
                    </div>
                </Dropdown>


                <div className={style.navBlock} onClick={() => {
                    navigate('/license')
                }}>
                    证书管理
                </div>

                <div className={style.navBlock} onClick={() => {
                    navigate('/customerService')
                }}>
                    客户服务
                </div>

                <div className={style.navBlock} onClick={() => {
                    navigate('/downloadCenter')
                }}>
                    下载中心
                </div>


                <div className={style.navBlock} onClick={() => {
                    navigate('/hireInformation')
                }}>
                    招聘信息
                </div>

                <div className={style.rightNavBlock} onClick={() => {
                    navigate('/contact')
                }}>
                    联系我们
                </div>
            </div>
            <div>
                {path === '/index' ? (
                    <div className={style.mainContainer}>
                        <div className={style.topSwiper}>
                            <Carousel style={{paddingTop: 10}} autoplay effect="fade" autoplaySpeed={6000}>
                                <img src={bac_1} height={370} alt=""/>
                                <img src={bac_2} height={370} alt=""/>
                                <img src={bac_3} height={370} alt=""/>

                            </Carousel>
                        </div>

                        <div className={style.mainSecondBlock}>
                            <div className={style.smallSwiper}>
                                <Carousel autoplay>
                                    <img src={s_bac_1} style={{width: '100%'}} height={260} alt=""/>
                                    <img src={s_bac_2} style={{width: '100%'}} height={260} alt=""/>
                                    <img src={s_bac_3} style={{width: '100%'}} height={260} alt=""/>
                                </Carousel>
                            </div>

                            <div className={style.noticeArea}>
                                <Tabs
                                    centered
                                    defaultActiveKey="1"
                                    type="card"
                                    size={"middle"}
                                    items={noticeItems}
                                    style={{width: '100%'}}
                                />
                            </div>
                        </div>

                        <div className={style.mainThirdBlock}>
                            <div className={style.mainThirdBlockFirstArea}>
                                <div className={style.cardLine}>
                                    <Card size="small" className={style.card} title="政策法规"
                                          extra={<Button type={'link'} onClick={() => {
                                              navigate('/information', {state: {subPath: 'c3'}})
                                          }}>查看更多</Button>}>
                                        <div>
                                            {lawData?.map((d: any) => (
                                                <div className={style.cardEachItem} onClick={() => {
                                                    navigate('/information', {state: {subPath: 'c3', articleId: d?.id}})
                                                }}>{d?.name}</div>
                                            ))}
                                        </div>
                                    </Card>

                                    <Card size="small" className={style.card} title="下载中心"
                                          extra={<Button type={'link'} onClick={() => {
                                              navigate('/downloadCenter')
                                          }}>查看更多</Button>}>
                                        <div>
                                            <div className={style.cardEachItem} onClick={() => {
                                                const url = `${comFile}LSC14-1-contract.doc`
                                                downloadFile(url);
                                            }}>
                                                LSC14-1产品认证合同书
                                            </div>
                                            {/*<div className={style.cardEachItem} onClick={() => {*/}
                                            {/*    const url = `${comFile}commitment.pdf`*/}
                                            {/*    downloadFile(url);*/}
                                            {/*}}>*/}
                                            {/*    承诺书(扫描件)*/}
                                            {/*</div>*/}
                                            {/*<div className={style.cardEachItem} onClick={() => {*/}
                                            {/*    const url = `${comFile}2-LSC-R-C01.pdf`*/}
                                            {/*    downloadFile(url);*/}
                                            {/*}}>*/}
                                            {/*    LSC-R-C01:2025 产品碳足迹认证实施规则 动力电池*/}
                                            {/*</div>*/}
                                            {/*<div className={style.cardEachItem} onClick={() => {*/}
                                            {/*    const url = `${comFile}2-LSC-R-C02.pdf`*/}
                                            {/*    downloadFile(url);*/}
                                            {/*}}>*/}
                                            {/*    LSC-R-C02：2025产品碳足迹认证实施规则  锂离子电池*/}
                                            {/*</div>*/}
                                            {/*<div className={style.cardEachItem} onClick={() => {*/}
                                            {/*    const url = `${comFile}LSC-G-SC-01.pdf`*/}
                                            {/*    downloadFile(url);*/}
                                            {/*}}>*/}
                                            {/*    LSC-G-SC-01公正性声明*/}
                                            {/*</div>*/}

                                            <div className={style.cardEachItem} onClick={() => {
                                                const url = `${comFile}LSC16-1.pdf`
                                                downloadFile(url);
                                            }}>
                                                LSC16-1产品认证申请书
                                            </div>


                                            <div className={style.cardEachItem} onClick={() => {
                                                const url = `${comFile}appeals.pdf`
                                                downloadFile(url);
                                            }}>
                                                申诉、投诉和争议须知
                                            </div>

                                        </div>
                                    </Card>
                                </div>

                                <div style={{marginTop: 20}} className={style.cardLine}>
                                    <div className={style.rePic}>
                                        <img src={re1} alt="" style={{width: '100%'}}/>
                                    </div>
                                    <div className={style.rePic}>
                                        <img src={re2} alt="" style={{width: '100%'}}/>
                                    </div>
                                </div>

                                <div style={{marginTop: 20}}>
                                    <Card size="small" className={style.serCard}
                                          title="产品认证（PV15蓄电池、原电池、原电池组和其他电池及其零件）">
                                        <div className={style.serCardZone}>
                                            <div className={style.serCardZoneLeftCard}>
                                                <div className={style.serCardEachItem}>
                                                    <img src={ca1} style={{width: '100%', height: "100%"}} alt=""/>
                                                </div>
                                                <div className={style.serCardEachItem}>
                                                    <img src={ca2} style={{width: '100%', height: "100%"}} alt=""/>
                                                </div>
                                                <div className={style.serCardEachItem}>
                                                    <img src={ca3} style={{width: '100%', height: "100%"}} alt=""/>
                                                </div>
                                                <div className={style.serCardEachItem}>
                                                    <img src={ca4} style={{width: '100%', height: "100%"}} alt=""/>
                                                </div>
                                                <div className={style.serCardEachItem}>
                                                    <img src={ca5} style={{width: '100%', height: "100%"}} alt=""/>
                                                </div>
                                                <div className={style.serCardEachItem}>
                                                    <img src={ca6} style={{width: '100%', height: "100%"}} alt=""/>
                                                </div>
                                                <div className={style.serCardEachItem}>
                                                    <img src={ca7} style={{width: '100%', height: "100%"}} alt=""/>
                                                </div>
                                                <div className={style.serCardEachItem}>
                                                    <img src={ca8} style={{width: '100%', height: "100%"}} alt=""/>
                                                </div>
                                                <div className={style.serCardEachItem}>
                                                    <img src={ca9} style={{width: '100%', height: "100%"}} alt=""/>
                                                </div>
                                            </div>
                                            <div className={style.serCardZoneRightCard}>
                                                <div className={style.serCardEachItem2}>
                                                    <img src={professionalIcon} style={{width: '80%', height: "80%"}}
                                                         alt=""/>
                                                    <div className={style.serEachTitle}>专业公正</div>
                                                </div>

                                                <div className={style.serCardEachItem2}>
                                                    <img src={clockIcon} style={{width: '80%', height: "80%"}} alt=""/>
                                                    <div className={style.serEachTitle}>高效服务</div>
                                                </div>

                                                <div className={style.serCardEachItem2}>
                                                    <img src={priceIcon} style={{width: '80%', height: "80%"}} alt=""/>
                                                    <div className={style.serEachTitle}>价格透明</div>
                                                </div>
                                            </div>
                                            {/*<div className={style.serCardEachItem}>*/}
                                            {/*    <img src={ce1} style={{width: '100%'}} alt=""/>*/}
                                            {/*    <div style={{textAlign: 'center'}}>ISO9001认证</div>*/}
                                            {/*</div>*/}

                                            {/*<div className={style.serCardEachItem}>*/}
                                            {/*    <img src={ce2} style={{width: '100%'}} alt=""/>*/}
                                            {/*    <div style={{textAlign: 'center'}}>ISO14001认证</div>*/}
                                            {/*</div>*/}

                                            {/*<div className={style.serCardEachItem}>*/}
                                            {/*    <img src={ce3} style={{width: '100%'}} alt=""/>*/}
                                            {/*    <div style={{textAlign: 'center'}}>ISO45001认证</div>*/}
                                            {/*</div>*/}

                                            {/*<div className={style.serCardEachItem}>*/}
                                            {/*    <img src={ce4} style={{width: '100%'}} alt=""/>*/}
                                            {/*    <div style={{textAlign: 'center'}}>GB/T50430认证</div>*/}
                                            {/*</div>*/}


                                        </div>
                                    </Card>
                                </div>
                            </div>
                            <div className={style.mainThirdBlockSecondArea}>
                                <div className={style.additionalMainBlock}>
                                    <div>
                                        <Button className={style.additionalButtonEachBtn}
                                                type="primary" onClick={() => {
                                            showWarning("敬请期待!~");
                                        }}>申请方需知</Button>
                                        <Button className={style.additionalButtonEachBtn}
                                                type="primary" onClick={() => {
                                            navigate('/certificateNotice', {state: {subPath: 'c2'}})
                                        }}>认证流程</Button>
                                        <Button className={style.additionalButtonEachBtn}
                                                type="primary" onClick={() => {
                                            navigate('/certificateNotice', {state: {subPath: 'c3'}})
                                        }}>认证收费</Button>
                                        <Button className={style.additionalButtonEachBtn}
                                                type="primary" onClick={() => {
                                            showWarning("敬请期待!~");
                                        }}>在线申请认证</Button>
                                    </div>

                                    <div className={style.additionalIconBlock}>
                                        <div className={style.eachItem} onClick={() => {
                                            // showWarning("敬请期待!~");
                                            navigate('/certSearch')
                                        }}>
                                            <img width={50} height={50} src={searchIcon} alt=""/>
                                            <div style={{marginTop: 15}}>证书查询</div>
                                        </div>

                                        <div className={style.eachItem} onClick={() => {
                                            showWarning("敬请期待!~");
                                        }}>
                                            <img width={50} height={50} src={onlineIcon} alt=""/>
                                            <div style={{marginTop: 15}}>在线办公</div>
                                        </div>

                                        <div className={style.eachItem} onClick={() => {
                                            showFail("无权限!");
                                        }}>
                                            <img width={50} height={50} src={auditIcon} alt=""/>
                                            <div style={{marginTop: 15}}>审核员专区</div>
                                        </div>

                                        <div className={style.eachItem} onClick={() => {
                                            showWarning("敬请期待!~");
                                        }}>
                                            <img width={50} height={50} src={cpAuditIcon} alt=""/>
                                            <div style={{marginTop: 15}}>人员资质查询</div>
                                        </div>
                                    </div>

                                    <Divider style={{
                                        borderColor: '#0052a6',
                                        fontWeight: 'bold',
                                        fontSize: '1.2rem'
                                    }}>互动交流</Divider>

                                    <Button className={style.additionalButtonEachBtn} onClick={() => {
                                        showWarning("敬请期待!~");
                                    }}>投诉与建议</Button>

                                    <div className={style.qrCode}>
                                        <img src={qrCode} style={{width: '100%', height: "100%"}} alt=""/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{marginTop: 50}} className={style.mainFourthBlock}>
                            <Card size="small" className={style.serCard} title="友情链接"
                                  extra={<a href="#">More</a>}>
                                <div className={style.linkCardZone}>
                                    <div className={style.linkCardEachItem} onClick={() => {
                                        window.open('http://samr.saic.gov.cn/', '_blank')
                                    }}>
                                        <img src={linkPic1} style={{width: '100%'}} alt=""/>
                                    </div>

                                    <div className={style.linkCardEachItem} onClick={() => {
                                        window.open('http://www.cnca.gov.cn/', '_blank')
                                    }}>
                                        <img src={linkPic2} style={{width: '100%'}} alt=""/>
                                    </div>

                                    <div className={style.linkCardEachItem} onClick={() => {
                                        window.open('https://www.cnas.org.cn/', '_blank')
                                    }}>
                                        <img src={linkPic3} style={{width: '100%'}} alt=""/>
                                    </div>

                                    <div className={style.linkCardEachItem} onClick={() => {
                                        window.open('https://www.iaf.nu/', '_blank')
                                    }}>
                                        <img src={linkPic4} style={{width: '100%'}} alt=""/>
                                    </div>

                                    <div className={style.linkCardEachItem} onClick={() => {
                                        window.open('http://www.ccaa.org.cn/', '_blank')
                                    }}>
                                        <img src={linkPic5} style={{width: '100%'}} alt=""/>
                                    </div>

                                    <div className={style.linkCardEachItem} onClick={() => {
                                        window.open('http://www.sac.gov.cn/', '_blank')
                                    }}>
                                        <img src={linkPic6} style={{width: '100%'}} alt=""/>
                                    </div>

                                    <div className={style.linkCardEachItem} onClick={() => {
                                        window.open('http://www.cnis.gov.cn/', '_blank')
                                    }}>
                                        <img src={linkPic7} style={{width: '100%'}} alt=""/>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                ) : path === '/about' ? (
                    <SecondPage/>
                ) : path === '/certification' ? (
                    <ThirdPage/>
                ) : path === '/information' ? (
                    <FourthPage/>
                ) : path === '/license' ? (
                    <FifthPage/>
                ) : path === '/customerService' ? (
                    <SixthPage/>
                ) : path === '/downloadCenter' ? (
                    <SeventhPage/>
                ) : path === '/hireInformation' ? (
                    <HireInformation/>
                ) : path === '/certificateNotice' ? (
                    <CertificateNotice/>
                ) : path === '/contact' ? (
                        <EighthPage/>)
                    : path === '/certSearch' ? (
                            <CertSearch/>)
                        : (<div/>)}
            </div>

            <div className={style.footer}>
                <div className={style.footerFirstLine}>
                    <div className={style.footerFirstLineEachItem} onClick={() => {
                        navigate('/about', {state: {subPath: 'c1'}})
                    }}>关于我们
                    </div>
                    <div className={style.footerFirstLineEachItem} onClick={() => {
                        navigate('/certification', {state: {subPath: 'c1'}})
                    }}>认证服务
                    </div>
                    <div className={style.footerFirstLineEachItem} onClick={() => {
                        navigate('/customerService')
                    }}>客户服务
                    </div>
                    <div className={style.footerFirstLineEachItemEnd} onClick={() => {
                        navigate('/contact')
                    }}>联系我们
                    </div>
                </div>

                <div className={style.footerCorporate}>
                    © 2024 湖州市两山生态资源认证有限公司版权所有
                </div>

                <div className={style.filingWrapper}>
                    <div className={style.filingText} onClick={() => {
                        window.open('https://beian.miit.gov.cn/#/Integrated/recordQuery', '_blank')
                    }}>ICP备案号: 浙ICP备2025218084号</div>
                </div>

                <div className={style.filingWrapper}>
                    <img width={25} height={25} style={{marginRight: 10}} src={filingPng} alt=""/>
                    {/*<div className={style.filingText} onClick={() => {*/}
                    {/*    window.open('https://beian.miit.gov.cn/#/Integrated/recordQuery', '_blank')*/}
                    {/*}}>浙公网安备33059102000460号</div>*/}
                    <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33059102000460" rel="noreferrer" target="_blank">浙公网安备33059102000460号</a >
                </div>

            </div>

        </div>
    );
};

export default FirstPage;